import React, { useState } from "react";
import { Tooltip, ClipboardCopyButton } from "@patternfly/react-core";
import CopyIcon from "@patternfly/react-icons/dist/esm/icons/copy-icon";
import CheckIcon from "@patternfly/react-icons/dist/esm/icons/check-icon";

const CopyIconButton = ({ text, id, style }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();

    navigator.clipboard.writeText(text);
    setCopied(true);

    // reset tooltip po 1.5s
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Tooltip content={copied ? "Skopiowano ✓" : "Kopiuj"}>
      <ClipboardCopyButton
        style={style}
        variant="plain"
        hasNoPadding
        id={`copy-${id}`}
        aria-label="Kopiuj"
        onClick={handleCopy}
        icon={copied ? <CheckIcon /> : <CopyIcon />}
      />
    </Tooltip>
  );
};

export default CopyIconButton;